/** The inventory feature's URL segments, used by routes. */
export const INVENTORY_SEGMENT = "inventory";
export const INVENTORY_LIST_SEGMENT = "list";
export const INVENTORY_SNAPSHOT_SEGMENT = "snapshot";

/** The inventory feature's full paths, used by navigation and links. */
export const INVENTORY_PATH = `/${INVENTORY_SEGMENT}`;
export const INVENTORY_LIST_PATH = `${INVENTORY_PATH}/${INVENTORY_LIST_SEGMENT}`;
export const INVENTORY_SNAPSHOT_PATH = `${INVENTORY_PATH}/${INVENTORY_SNAPSHOT_SEGMENT}`;
